<template>
  <div class="px-3">
    <v-card outlined>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-subtitle class="font-weight-bold"
        >Total: {{ totalValue }}</v-card-subtitle
      >
      <v-row>
        <v-col md="12">
          <canvas class="my-canvas" :id="id"></canvas>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    chartType: { type: String, default: "bar" },
    chartData: { type: Object, default: null },
    chartOptions: { type: Object, default: null },
    chartText: { type: String, default: "" },
    id: { type: String, default: "myChart" },
    totalValue: { type: Number, default: 0 },
    title: { type: String, default: "" },
  },
  mounted() {
    //let { chartType, chartData, chartOptions } = this;
    this.chartConstructor(this.chartType, this.chartData, this.chartOptions);
  },
  data() {
    return {
      chart: null,
      chartDefaultData: {
        labels: ["Pre", "During", "Post"],
        datasets: [
          {
            data: [61, 100, 14],
          },
        ],
      },
    };
  },
  watch: {
    chartData: function (newData) {
      this.chart.data.datasets.datasets = newData;
      this.chart.update();
      this.chartConstructor(this.chartType, this.chartData, this.chartOptions);
    },
  },
  methods: {
    chartConstructor(chartType, chartData, chartOptions) {
      const chartElement = document.getElementById(this.id);

      this.chart = new Chart(chartElement, {
        type: chartType,
        data: chartData,
        options: chartOptions,
      });

      // this.chart.update();
    },
    updateChart() {
      this.chartConstructor(this.chartType, this.chartData, this.chartOptions);
    },
    destroyChart() {
      this.chart.destroy();
    },
  },
};
</script>

<style scoped>
.my-canvas {
}
</style>

